import { render, staticRenderFns } from "./AliveNav.vue?vue&type=template&id=3bf4335e&scoped=true"
import script from "./AliveNav.vue?vue&type=script&lang=js"
export * from "./AliveNav.vue?vue&type=script&lang=js"
import style0 from "./AliveNav.vue?vue&type=style&index=0&id=3bf4335e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4335e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf4335e')) {
      api.createRecord('3bf4335e', component.options)
    } else {
      api.reload('3bf4335e', component.options)
    }
    module.hot.accept("./AliveNav.vue?vue&type=template&id=3bf4335e&scoped=true", function () {
      api.rerender('3bf4335e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/components/AliveNav.vue"
export default component.exports